import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext.jsx';

export function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    const loc = useLocation();
    if (loading) {
        return (
            <div className="grid min-h-dvh place-items-center text-ink-500">
                <div className="font-mono text-sm">Loading…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
    return children;
}
